import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const initDataForm = {
  nombre: "",
  nit: "",
  nombre_contacto: "",
  telefono: "",
  email: "",
  idioma: "",
  zona_horaria:"",
};

const errorsInit = {
  ...initDataForm,
};

const NuevoEmpresa = ({
  agregarNuevoEmpresa,
  clienteempre,
  editar = false,
  editarEmpresa,
}) => {
  const [dataForm, setDataForm] = useState(initDataForm);
  const [errors, setErrors] = useState(errorsInit);

  useEffect(() => {
    if (editar) {
      setDataForm({ ...clienteempre });
    }
  }, []);

  const handleChange = (e) => {
    setDataForm({ ...dataForm, [e.target.name]: e.target.value });
    setErrors({ ...errorsInit });
  };

  const isValid = () => {
    const localErrors = { ...errorsInit };
    let respuesta = true;

    for (let key in dataForm) {
      console.log("errores", key)
      if (key !== "id" ) {
        if (dataForm[key].trim() === "" ||dataForm[key].trim() === "Seleccione" || dataForm[key].length === 0) {
          localErrors[key] = "campo requerido";
          respuesta = false;
        }
      }
    }

    setErrors({ ...localErrors });

    return respuesta;
  };

  const handleSubmit = (e) => {
    const dataForm1 = { ...dataForm };
    e.preventDefault();
    if (isValid()) {
      // mandar la data al proveedor
      if (editar) {
        console.log("empresa", dataForm)
        editarEmpresa(dataForm);
      } else {
        agregarNuevoEmpresa(dataForm1);
      }
      // limpiar los campos
      setDataForm(initDataForm);
    }
  };

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8 ">
            <div
              className="card card-primary shadow-lg p-3 mb-5 bg-white rounded"
              style={{ padding: "0em" }}
            >
              <div className="card-header">
                {editar ? (
                  <h1 className="card-title">Editar Empresa</h1>
                ) : (
                  <h1 className="card-title">Agregar Empresa</h1>
                )}
              </div>
              <form onSubmit={handleSubmit} style={{ maxWidth: "50em" }}>
                <div className="form-row">
                  <div className="form-group col-md-4">
                    <label htmlFor="nombre">Nombre</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nombre"
                      value={dataForm.nombre}
                      onChange={handleChange}
                    />
                    {errors.nombre && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {errors.nombre}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="nit">NIT || RUC</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nit"
                      value={dataForm.nit}
                      onChange={handleChange}
                    />
                    {errors.nit && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {errors.nit}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="nombre_contacto">Nombre Contacto</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nombre_contacto"
                      value={dataForm.nombre_contacto}
                      onChange={handleChange}
                    />
                    {errors.nombre_contacto && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {errors.nombre_contacto}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-4">
                    <label htmlFor="idioma">Idioma</label>
                    <select
                      type="text"
                      className="form-control"
                      name="idioma"
                      value={dataForm.idioma}
                      onChange={handleChange}
                    >
                      <option value="-1">Seleccione</option>
                      <option>Espanol</option>
                      <option>Ingles</option>
                    
                    </select>
                    {errors.idioma && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {errors.idioma}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="telefono">Telefono</label>
                    <input
                      type="text"
                      className="form-control"
                      name="telefono"
                      value={dataForm.telefono}
                      onChange={handleChange}
                    />
                    {errors.telefono && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {errors.telefono}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="email">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      value={dataForm.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {errors.email}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="zona_horaria">Zona Horaria</label>
                    <input
                      type="text"
                      className="form-control"
                      name="zona_horaria"
                      value={dataForm.zona_horaria}
                      onChange={handleChange}
                    />
                    {errors.zona_horaria && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        {errors.zona_horaria}
                      </span>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <button type="submit" className="btn btn-primary">
                    {editar ? "Editar Empresa" : "Agregar Empresa"}
                  </button>
                  <Link className="btn btn-warning ml-2" to={`/clienteempre`}>
                    Cancelar
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NuevoEmpresa;
